module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal__mask",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__wrapper"
  }, [_c('table', {
    staticClass: "modal__container",
    on: {
      "click": _vm.preventClose
    }
  }, [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "field email",
    class: {
      error: _vm.isEmailError
    },
    attrs: {
      "disabled": _vm.isLocked,
      "type": "email",
      "placeholder": "Your email",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.isEmailError = false
      }],
      "change": function($event) {
        _vm.isEmailError = false
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "field message",
    attrs: {
      "disabled": _vm.isLocked,
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "modal__button",
    class: {
      touch: _vm.isTouch
    },
    on: {
      "click": _vm.send
    }
  }, [_c('div', {
    staticClass: "modal__button__blinder",
    class: {
      active: _vm.isSent
    }
  }, [_c('div', {
    staticClass: "modal__button__message"
  }, [_vm._v("sent")])]), _vm._v("\n                        send\n                    ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34131a12","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/contact.vue
// module id = 135
// module chunks = 1